<template>
    <va-create-layout>
        <CouponPaymentEvent-form
            :title="title"
            :item="item"
        ></CouponPaymentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
